export const DESKTOP_FILTERS_MICROFRONTEND_MANIFEST = 'desktopFiltersMicrofrontendManifest';
